import { clientSDK } from "@istari-frontend/api-client";
import { queryOptions } from "@tanstack/react-query";

import { DEFAULT_CACHE_TIME } from "~/constants";

import { toSystem } from "./adapter/to-system";

export const systemQueryKeys = {
  all: ["system"] as const,
  detail: (systemId: string) => [...systemQueryKeys.all, systemId] as const,
};

export const systemQueryOptions = (systemId: string) =>
  queryOptions({
    queryKey: systemQueryKeys.detail(systemId),
    queryFn: () => clientSDK.getSystem(systemId),
    select: toSystem,
    staleTime: DEFAULT_CACHE_TIME,
  });
